import uniqBy from 'lodash/uniqBy';

import {
  DOOR_DELETE_SUCCESS,
  GET_DOORS_SUCCESS,
  GET_DOOR_SUCCESS,
} from '../actionConstants';

import { isAdmin } from '../utils';

const defaultState = [];

export default (state = defaultState, action) => {
  const { type, res, doorId, removePrev = true } = action;
  switch (type) {
    case GET_DOORS_SUCCESS:
    case GET_DOOR_SUCCESS: {
      // some legacy endpoints may return `res.data.data`
      // TODO - check if they exist
      let allDoors = res.data.data || res.data || [];

      if (!Array.isArray(allDoors)) {
        allDoors = [allDoors];
      }

      // only admin can see disabled doors
      // `disabled` flag is not returned for PMC
      const shownDoors = isAdmin()
        ? allDoors
        : allDoors.filter(({ disabled }) => !disabled);

      // for brokers we need to keep doors for different properties
      // in this case prev doors shouldn't be removed and should be unique
      return removePrev ? shownDoors : uniqBy([...state, ...shownDoors], 'id');
    }
    case DOOR_DELETE_SUCCESS: {
      const doors = [...state];
      return doors.filter(({ id }) => id !== doorId);
    }

    case '@@router/LOCATION_CHANGE':
      return defaultState;

    default:
      return state;
  }
};
